import { ArrowUturnRightIcon } from '@heroicons/react/24/outline'

const AlertPostponed = ({ onlyIcon = false }) => (
  <div className="flex justify-center items-center">
    <ArrowUturnRightIcon className="h-4 w-4" />
    {!onlyIcon && <p className="ml-1 text-[15px]">Ajornat</p>}
  </div>
)

export default AlertPostponed
